import EastIcon from '@mui/icons-material/East';
import { Box, styled } from '@mui/material';
import { Link } from '~/components/Link';
import {
  ContentContainer,
  Kicker,
  SectionH2,
  SectionHeadRow,
} from '~/components/HomepageV3/styles';
import { ReportCard } from '~/components/ReportCard';
import { usePopularReports } from '~/components/HomepageV3/usePopularReports';

export const PopularReportsSection = () => {
  const popularReports = usePopularReports();

  return (
    <ContentContainer sx={{ pb: 12 }}>
      <SectionHeadRow>
        <div>
          <Kicker>Popular intel</Kicker>
          <SectionH2>Reports the community runs daily.</SectionH2>
        </div>
        <Link href="/technologies" className="design-link" underline="hover">
          Browse all reports
          <EastIcon sx={{ fontSize: 14, ml: 0.5 }} />
        </Link>
      </SectionHeadRow>

      <ReportsGrid>
        {popularReports.map((report) => {
          return (
            <ReportCard
              href={report.url}
              key={report.uuid}
              name={report.name}
              uuid={report.uuid}
              category={report.category}
              description={report.description}
              footer={
                <>
                  <strong>{report.total.toLocaleString()}</strong> matches
                </>
              }
            />
          );
        })}
      </ReportsGrid>
    </ContentContainer>
  );
};

const ReportsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;
